module.exports = __webpack_public_path__ + "static/media/profile_image.24299bc4.png";